// extracted by mini-css-extract-plugin
module.exports = {"confirmMsg":"_5ZtUfI","joinButtons":"_2cLtmW","loginButtons":"_1LQFEZ"};